module.exports = __webpack_public_path__ + "img/cabin.19a42cc2.svg";